<template>
  <AbaDownload :titulo="titulo" v-if="!loading">
    <div slot="subtitulo" class="segunda-cor-fonte">
      <p>
        Filtrando Unimeds por:
        <span v-if="mensagemFiltroUnimeds.length < tamanhoMaximoTexto">{{
          mensagemFiltroUnimeds
        }}</span>
        <unicom-tooltip
          v-else
          style="display: inline-block;"
          :texto="
            `${mensagemFiltroUnimeds.substring(0, tamanhoMaximoTexto)}...`
          "
          :textoTooltip="mensagemFiltroUnimeds"
          :whiteSpaceNoWrap="false"
        />
        E estados por:
        <span v-if="mensagemFiltroEstados.length < tamanhoMaximoTexto">{{
          mensagemFiltroEstados
        }}</span>
        <unicom-tooltip
          v-else
          style="display: inline-block;"
          :texto="
            `${mensagemFiltroEstados.substring(0, tamanhoMaximoTexto)}...`
          "
          :textoTooltip="mensagemFiltroEstados"
          :whiteSpaceNoWrap="false"
        />
      </p>
    </div>
    <div style="width: 100%; text-align: center">
      <div class="container-vertical-redes">
        <CardVerticalDownload
          v-for="arquivo in arrayArquivos"
          :key="arquivo.rede.chave"
          :valor="arquivo.rede.chave"
          :selecionado="selecionado"
          :titulo="arquivo.rede.descricao"
          :subtitulo="arquivo.quantidadeArquivos + ' arquivos'"
          @selecionar="selecionar"
        />
      </div>

      <unicom-botao @click="baixar" nomeIcone="download-cloud" :largura="360">
        {{ mensagemBotaoBaixar }}
      </unicom-botao>
    </div>
  </AbaDownload>
  <unicom-spinner
    v-else
    style="
      min-height: 450px;
      display: flex;
      flex-flow: wrap column;
      justify-content: center;
    "
    :tamanhoLoading="62"
    :tamanhoLinha="7"
    :velocidade="0.5"
    :marginTopTexto="30"
    mensagem="Carregando..."
  />
</template>

<script>
import AbasMixin from "../AbasMixin";
import AbaDownloadMixin from "../AbaDownloadMixin";

export default {
  mixins: [AbasMixin, AbaDownloadMixin],
  data() {
    let arrayArquivos = [];

    arrayArquivos = [
      {
        rede: {
          chave: "BASICA",
          descricao: "Rede básica"
        },
        quantidadeArquivos: 3
      },
      {
        rede: {
          chave: "ESPECIAL",
          descricao: "Rede especial"
        },
        quantidadeArquivos: 3
      },
      {
        rede: {
          chave: "MASTER",
          descricao: "Rede master"
        },
        quantidadeArquivos: 3
      }
    ];

    return {
      loading: false,
      arrayArquivos,
      selecionado: arrayArquivos.map(e => e.rede.chave),
      tamanhoMaximoTexto: 50
    };
  },
  methods: {
    selecionar(valor) {
      let index = this.selecionado.indexOf(valor);

      if (index !== -1) {
        if (this.selecionado.length === 1) return;

        this.selecionado.splice(index, 1);
        return;
      }
      this.selecionado.push(valor);
    },
    async baixar() {
      this.$store.commit("setLoadingModal", true);

      for await (let e of this.selecionado) {
        let response = await this.getDownloadArpsRpsAns({
          rede: e,
          ...this.paramsFiltro
        });

        if (response.status === 204) {
          this.$store.commit("setLoadingModal", false);
          return;
        } else {
          this.$helpers.baixarArquivo(
            response.data,
            response.headers["content-disposition"]
          );
        }
      }

      this.$store.commit("setLoadingModal", false);
    }
  },
  computed: {
    mensagemFiltroEstados() {
      const { estados = [] } = this.objetoFiltro;

      return estados.length
        ? estados.map(({ chave }) => chave).join(", ") + "."
        : "";
    },
    mensagemFiltroUnimeds() {
      const { unimeds = [] } = this.objetoFiltro;

      return unimeds.length
        ? unimeds.map(({ textoExibicao }) => textoExibicao).join(", ") + "."
        : "";
    },
    paramsFiltro() {
      const { cdUnimeds = [], ufs = [], competencia = "" } = this.objetoFiltro;

      if (cdUnimeds.length && !ufs.length) {
        return { cdUnimeds };
      } else if (!cdUnimeds.length && ufs.length) {
        return { ufs };
      } else if (cdUnimeds.length && ufs.length && !competencia.length) {
        return { cdUnimeds, ufs };
      } else if (cdUnimeds.length && ufs.length && competencia.length) {
        return { cdUnimeds, ufs, competencia };
      }

      return {};
    },
    mensagemBotaoBaixar() {
      if (this.selecionado.length === 1) {
        let descricao = this.arrayArquivos.find(
          e => e.rede.chave === this.selecionado[0]
        ).rede.descricao;
        return "BAIXAR " + descricao.toUpperCase();
      } else if (this.selecionado.length === 2) {
        return "BAIXAR SELECIONADOS";
      } else if (this.selecionado.length === this.arrayArquivos.length) {
        return "BAIXAR TODOS";
      }

      return "BAIXAR";
    }
  }
};
</script>

<style lang="scss" scoped>
.container-vertical-redes {
  display: flex;
  flex-flow: wrap;
  justify-content: center;
}
</style>
